import type { ToolBadgeSpec } from '../types.js';

import { readField, readString } from '../extractors.js';

export const fetchSabreHotelDetailsSpec: ToolBadgeSpec = {
  toolName: 'fetchSabreHotelDetails',
  aliases: ['sabreGetHotelDetails'],
  icon: 'hotel',
  label: (_, active) => (active ? 'Getting hotel details' : 'Fetched hotel details'),
  resultNoun: { singular: 'hotel', plural: 'hotels' },
  extractResults: (toolCall) => {
    const output = toolCall.output;
    const id = readString(readField(output, 'id'));
    const name = readString(readField(output, 'name'));
    if (!id || !name) return undefined;
    return { items: [{ key: id, title: name, previewType: 'hotel', id }] };
  },
};
